var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 204,
    viewBox: "0 0 205 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 191.284,
    y: 102.172,
    width: 9,
    height: 9,
    transform: "rotate(-45 191.284 102.172)",
    fill: "#FDCF00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179.971,
    y: 89.4435,
    width: 8,
    height: 8,
    transform: "rotate(-45 179.971 89.4435)",
    fill: "#FDCF00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.086,
    y: 77.8369,
    width: 7,
    height: 7,
    transform: "rotate(-45 168.086 77.8369)",
    fill: "#FDCF00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 155.935,
    y: 65.2909,
    width: 6.5,
    height: 6.5,
    transform: "rotate(-45 155.935 65.2909)",
    fill: "#FDCF00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 143.971,
    y: 52.452,
    width: 6,
    height: 6,
    transform: "rotate(-45 143.971 52.452)",
    fill: "#FDCF00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 40.3203,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 40.3203)",
    fill: "#FDCF00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 27.8184,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 27.8184)",
    fill: "#FDCF00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 14.7737,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 14.7737)",
    fill: "#FDCF00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 14.7737,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 14.7737)",
    fill: "#FDCF00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 14.7737,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 14.7737)",
    fill: "#FDCF00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5352,
    y: 14.7737,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 35.5352 14.7737)",
    fill: "#FDCF00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6582,
    y: 14.7737,
    width: 1,
    height: 1,
    transform: "rotate(-45 11.6582 14.7737)",
    fill: "#FDCF00"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 2.89502,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 2.89502)",
    fill: "#FDCF00"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 2.89502,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 2.89502)",
    fill: "#FDCF00"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 2.89502,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 2.89502)",
    fill: "#FDCF00"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2432,
    y: 2.89502,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 23.2432 2.89502)",
    fill: "#FDCF00"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0732422,
    y: 2.89502,
    width: 1,
    height: 1,
    transform: "rotate(-45 0.0732422 2.89502)",
    fill: "#FDCF00"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 27.8184,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 27.8184)",
    fill: "#FDCF00"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 27.8184,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 27.8184)",
    fill: "#FDCF00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 27.8184,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 27.8184)",
    fill: "#FDCF00"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2432,
    y: 27.8184,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 23.2432 27.8184)",
    fill: "#FDCF00"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 52.452,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 52.452)",
    fill: "#FDCF00"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 52.452,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 52.452)",
    fill: "#FDCF00"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 52.452,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 52.452)",
    fill: "#FDCF00"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 77.8369,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 77.8369)",
    fill: "#FDCF00"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 77.8369,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 77.8369)",
    fill: "#FDCF00"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 102.172,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 102.172)",
    fill: "#FDCF00"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 127.877,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 127.877)",
    fill: "#FDCF00"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 127.877,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 127.877)",
    fill: "#FDCF00"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 153.261,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 153.261)",
    fill: "#FDCF00"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 153.261,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 153.261)",
    fill: "#FDCF00"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 153.261,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 153.261)",
    fill: "#FDCF00"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 176.181,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 176.181)",
    fill: "#FDCF00"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 176.181,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 176.181)",
    fill: "#FDCF00"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 176.181,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 176.181)",
    fill: "#FDCF00"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2432,
    y: 176.181,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 23.2432 176.181)",
    fill: "#FDCF00"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7314,
    y: 201.105,
    width: 3.5,
    height: 3.5,
    transform: "rotate(-45 95.7314 201.105)",
    fill: "#FDCF00"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7041,
    y: 201.105,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 71.7041 201.105)",
    fill: "#FDCF00"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 201.105,
    width: 2,
    height: 2,
    transform: "rotate(-45 47.1201 201.105)",
    fill: "#FDCF00"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2432,
    y: 201.105,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 23.2432 201.105)",
    fill: "#FDCF00"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0732422,
    y: 201.105,
    width: 1,
    height: 1,
    transform: "rotate(-45 0.0732422 201.105)",
    fill: "#FDCF00"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 40.3203,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 40.3203)",
    fill: "#FDCF00"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 40.3203,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 40.3203)",
    fill: "#FDCF00"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 40.3203,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 40.3203)",
    fill: "#FDCF00"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5352,
    y: 40.3203,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 35.5352 40.3203)",
    fill: "#FDCF00"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 65.2909,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 65.2909)",
    fill: "#FDCF00"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 65.2909,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 65.2909)",
    fill: "#FDCF00"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 65.2909,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 65.2909)",
    fill: "#FDCF00"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 89.4435,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 89.4435)",
    fill: "#FDCF00"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 89.4435,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 89.4435)",
    fill: "#FDCF00"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 114.9,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 114.9)",
    fill: "#FDCF00"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 114.9,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 114.9)",
    fill: "#FDCF00"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 140.422,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 140.422)",
    fill: "#FDCF00"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 140.422,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 140.422)",
    fill: "#FDCF00"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 140.422,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 140.422)",
    fill: "#FDCF00"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 165.393,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 165.393)",
    fill: "#FDCF00"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 165.393,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 165.393)",
    fill: "#FDCF00"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 165.393,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 165.393)",
    fill: "#FDCF00"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5352,
    y: 165.393,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 35.5352 165.393)",
    fill: "#FDCF00"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 108.159,
    y: 189.033,
    width: 4,
    height: 4,
    transform: "rotate(-45 108.159 189.033)",
    fill: "#FDCF00"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3643,
    y: 189.033,
    width: 3,
    height: 3,
    transform: "rotate(-45 83.3643 189.033)",
    fill: "#FDCF00"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4121,
    y: 189.033,
    width: 2,
    height: 2,
    transform: "rotate(-45 59.4121 189.033)",
    fill: "#FDCF00"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5352,
    y: 189.033,
    width: 1.5,
    height: 1.5,
    transform: "rotate(-45 35.5352 189.033)",
    fill: "#FDCF00"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6582,
    y: 189.033,
    width: 1,
    height: 1,
    transform: "rotate(-45 11.6582 189.033)",
    fill: "#FDCF00"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 52.452,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 52.452)",
    fill: "#FDCF00"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 77.8369,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 77.8369)",
    fill: "#FDCF00"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 102.172,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 102.172)",
    fill: "#FDCF00"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 127.877,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 127.877)",
    fill: "#FDCF00"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 153.261,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 153.261)",
    fill: "#FDCF00"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 119.979,
    y: 176.181,
    width: 4.5,
    height: 4.5,
    transform: "rotate(-45 119.979 176.181)",
    fill: "#FDCF00"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 65.2909,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 65.2909)",
    fill: "#FDCF00"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 89.4435,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 89.4435)",
    fill: "#FDCF00"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 114.9,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 114.9)",
    fill: "#FDCF00"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 140.422,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 140.422)",
    fill: "#FDCF00"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 131.469,
    y: 165.393,
    width: 5.5,
    height: 5.5,
    transform: "rotate(-45 131.469 165.393)",
    fill: "#FDCF00"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 143.971,
    y: 77.8369,
    width: 6,
    height: 6,
    transform: "rotate(-45 143.971 77.8369)",
    fill: "#FDCF00"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 143.971,
    y: 102.172,
    width: 6,
    height: 6,
    transform: "rotate(-45 143.971 102.172)",
    fill: "#FDCF00"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 143.971,
    y: 127.877,
    width: 6,
    height: 6,
    transform: "rotate(-45 143.971 127.877)",
    fill: "#FDCF00"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 143.971,
    y: 153.261,
    width: 6,
    height: 6,
    transform: "rotate(-45 143.971 153.261)",
    fill: "#FDCF00"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 155.935,
    y: 89.4435,
    width: 6.5,
    height: 6.5,
    transform: "rotate(-45 155.935 89.4435)",
    fill: "#FDCF00"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 155.935,
    y: 114.9,
    width: 6.5,
    height: 6.5,
    transform: "rotate(-45 155.935 114.9)",
    fill: "#FDCF00"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 155.935,
    y: 140.422,
    width: 6.5,
    height: 6.5,
    transform: "rotate(-45 155.935 140.422)",
    fill: "#FDCF00"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 168.086,
    y: 102.172,
    width: 7,
    height: 7,
    transform: "rotate(-45 168.086 102.172)",
    fill: "#FDCF00"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 167.997,
    y: 127.877,
    width: 7,
    height: 7,
    transform: "rotate(-45 167.997 127.877)",
    fill: "#FDCF00"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 179.971,
    y: 114.9,
    width: 8,
    height: 8,
    transform: "rotate(-45 179.971 114.9)",
    fill: "#FDCF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.157b24836ee482a9f49db7c6f355288f.svg";
export { ForwardRef as ReactComponent };